export default {
    headTitle: 'Accueil - Kolsquare',
};
